import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import CameraEventRepository from "../../../repositories/CameraEventRepository";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Button from "@material-ui/core/Button";
import { useConfirm } from "material-ui-confirm";

import ChangesPreview from "../ChangesPreview";
import useAlert from "../../../hooks/useAlert";
import Details from "./Details";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LprEventDetailView = ({ id, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [changes, setChanges] = useState(null);
  const [eventData, setEventData] = useState(null);
  const [showPreviewChanges, setShowPreviewChanges] = useState(null);
  const confirm = useConfirm();
  const repository = new CameraEventRepository();

  useEffect(async () => {
    try {
      const rs = await repository.getById(id);
      setEventData(rs.data);
    } catch (e) {
      handleClose();
    }
  }, [id]);

  const triggerClose = ({ isUpdated } = {}) => {
    if (onClose) {
      onClose({ id: id, isUpdated: isUpdated });
    }
  };

  const handleClose = () => {
    if (changes) {
      confirm({
        description: t("Changes will be lost do you really want to continue ?"),
      }).then(() => {
        triggerClose();
      });
      return;
    }
    triggerClose();
  };

  const handleEdit = (e) => {
    setChanges(e.changes);
  };

  const handleSaveChanges = async (e) => {
    if (!changes) {
      return;
    }

    setShowPreviewChanges(Object.assign({ Id: id }, changes));
  };

  const { showSuccess, showError } = useAlert();
  const handleApplyChanges = async () => {
    showSuccess(t("Changes have been applied"));
    triggerClose({ isUpdated: true });
  };

  const handleDeleteClick = async () => {
    await repository.delete(eventData.Id);
    triggerClose({ isUpdated: true });
  };

  return (
    <>
      {showPreviewChanges && (
        <ChangesPreview
          updateData={showPreviewChanges}
          onOk={handleApplyChanges}
          onClose={(e) => setShowPreviewChanges(null)}
        />
      )}
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={true}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {t("Lpr event")}
            </Typography>
          </Toolbar>
        </AppBar>
        {changes && (
          <Alert
            severity="warning"
            action={
              <Button color="inherit" size="medium" onClick={handleSaveChanges}>
                {t("Save")}
              </Button>
            }
          >
            <AlertTitle>{t("Warning")}</AlertTitle>
            {t("Event has been modified - click Save to apply changes")}
          </Alert>
        )}
        {eventData && (
          <Details
            eventData={eventData}
            onEdit={handleEdit}
            onDelete={handleDeleteClick}
          />
        )}
      </Dialog>
    </>
  );
};

export default LprEventDetailView;
